import { render, staticRenderFns } from "./KnStudentAccountStatus.vue?vue&type=template&id=db2b6cd4&"
import script from "./KnStudentAccountStatus.vue?vue&type=script&lang=js&"
export * from "./KnStudentAccountStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports